import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as styleHelpersStyles } from '../../../assets/style-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';
import { RebootTimes, VulnerableDriversAction } from '../types';

export const templateAntimalwareAntiTamperingPanel = document.createElement('template');

templateAntimalwareAntiTamperingPanel.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <style>${styleHelpersStyles}</style>

  <!-- anti-tampering policy section -->
  <div id="anti-tampering-policy-section">

    <div id="anti-tampering-section">
      <!-- anti-tampering checkbox form -->
      <gz-form-field id="anti-tampering-checkbox-form">
        <gz-checkbox gz-form-input id="anti-tampering-checkbox">
          <gz-title
            fontWeight="${FontWeights.MEDIUM}"
            fontSize="${FontSizes.HEADING_4}"
            id="anti-tampering-checkbox-title"
          >
          </gz-title>
        </gz-checkbox>
      </gz-form-field>
    </div>

    <div id="pre-tampering-section">
      <!-- pre-tampering title -->
      <gz-title fontWeight="${FontWeights.SEMIBOLD}" fontSize="${FontSizes.PARAGRAPH_11}" id="pre-tampering-title"></gz-title>

      <!-- pre-tampering text -->
      <gz-text fontWeight="${FontWeights.NORMAL}" fontSize="${FontSizes.PARAGRAPH_12}" id="pre-tampering-text"></gz-text>
    </div>

    <div id="vulnerable-drivers-section">
      <!-- vulnerable drivers checkbox form -->
      <gz-form-field id="vulnerable-drivers-checkbox-form">
        <gz-checkbox gz-form-input id="vulnerable-drivers-checkbox"></gz-checkbox>
      </gz-form-field>

      <!-- vulnerable drivers radio group form -->
      <gz-form-field id="vulnerable-drivers-radio-group-form">
        <gz-radio-group gz-form-input id="vulnerable-drivers-radio-group">
          <gz-radio value="${VulnerableDriversAction.DENY_ACCESS}" id="vulnerable-drivers-action-deny-access"></gz-radio>
          <gz-radio value="${VulnerableDriversAction.REMEDIATE}" id="vulnerable-drivers-action-remediate"></gz-radio>
          <gz-radio value="${VulnerableDriversAction.REPORT_ONLY}" id="vulnerable-drivers-action-report-only"></gz-radio>
        </gz-radio-group>
      </gz-form-field>
    </div>

    <div id="post-tampering-section">
      <!-- post-tampering title -->
      <gz-title fontWeight="${FontWeights.SEMIBOLD}" fontSize="${FontSizes.PARAGRAPH_11}" id="post-tampering-title"></gz-title>

      <!-- post-tampering text -->
      <gz-text fontWeight="${FontWeights.NORMAL}" fontSize="${FontSizes.PARAGRAPH_12}" id="post-tampering-text"></gz-text>
    </div>

    <div id="callback-evasion-section">
      <!-- callback evasion checkbox form -->
      <gz-form-field id="callback-evasion-checkbox-form">
        <gz-checkbox gz-form-input id="callback-evasion-checkbox"></gz-checkbox>
      </gz-form-field>

      <!-- callback evasion actions section-->
      <div id="callback-evasion-actions-section">

        <!-- isolate endpoint checkbox -->
        <gz-form-field class="pb-1" id="callback-evasion-actions-isolate-endpoint-checkbox-form">
          <gz-checkbox gz-form-input id="callback-evasion-actions-isolate-endpoint-checkbox"></gz-checkbox>
        </gz-form-field>

        <!-- reboot endpoint checkbox -->
        <gz-form-field id="callback-evasion-actions-reboot-endpoint-checkbox-form">
          <gz-checkbox gz-form-input id="callback-evasion-actions-reboot-endpoint-checkbox"></gz-checkbox>
        </gz-form-field>

        <!-- time options for reboot endpoint -->
        <gz-form-field id="callback-evasion-actions-radio-group-form">
          <gz-radio-group gz-form-input id="callback-evasion-actions-radio-group">
            <gz-radio value="${RebootTimes.IMMEDIATELY}" id="callback-evasion-action-immediately"></gz-radio>
            <gz-radio value="${RebootTimes.MIN_5}" id="callback-evasion-action-5-min"></gz-radio>
            <gz-radio value="${RebootTimes.MIN_10}" id="callback-evasion-action-10-min"></gz-radio>
            <gz-radio value="${RebootTimes.MIN_15}" id="callback-evasion-action-15-min"></gz-radio>
          </gz-radio-group>
        </gz-form-field>
      </div>
  </div>
`;
